.checkboxesContainer {
  display: flex;
  gap: var(--spacingLg);
  flex-wrap: wrap;
}

.visibilityCopy {
  color: var(--paletteBlue2);
}

.body {
  display: flex;
  flex-direction: column;
  gap: var(--spacingMd);
}
